<section class="cmn-innerpage-wrapper">
  <div class="inner-content dashboard">
    <div class="head">
      <h1>FAQ Management</h1>
      <div class="head-div">
        <div class="search-wrapper">
          <input
            type="text"
            class="cmn-header-search"
            placeholder="Search FAQ"
            (input)="onSearch($event)"
          />
        </div>
        <button
          *appHasPermission="'ADD_FAQ'"
          (click)="newFaq()"
          class="cmn-add-btn"
        >
          <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add FAQ
        </button>
      </div>
    </div>
    <div class="faq-wrapper" *ngIf="!loading">
      <cdk-accordion class="faq-accordion">
        @for (faq of faqList; track faq; let idx = $index) {
        <cdk-accordion-item
          #accordionItem="cdkAccordionItem"
          class="faq-item"
          [class.collapsed]="!accordionItem.expanded"
        >
          <div class="faq-title-section">
            <div class="faq-ques"></div>
            <div class="action-wrapper">
              <button
                *appHasPermission="'DELETE_FAQ'"
                (click)="deleteFaq(faq?.id)"
              >
                <img
                  src="../../../assets/images/icons/icon-delete.svg"
                  alt="delete"
                  class="action-icon"
                />
              </button>
              <button
                *appHasPermission="'UPDATE_FAQ'"
                (click)="onEditFaq(faq?.id)"
              >
                <img
                  src="../../../assets/images/icons/icon-edit.svg"
                  alt="edit"
                  class="action-icon"
                />
              </button>
            </div>
          </div>
          <button
            class="faq-question"
            (click)="accordionItem.toggle()"
            tabindex="0"
            [attr.id]="'faq-header-' + idx"
            [attr.aria-expanded]="accordionItem.expanded"
            [attr.aria-controls]="'faq-body-' + idx"
          >
            <h6>{{ getTranslationQuestion(faq) }}</h6>
            <span class="toggle-icon">
              <img
                *ngIf="!accordionItem.expanded"
                src="../../../assets/images/icons/icon-chevron-down.svg"
                alt="Expand"
                class="up-down-icon"
              />
              <img
                *ngIf="accordionItem.expanded"
                src="../../../assets/images/icons/icon-chevron-up.svg"
                alt="Collapse"
                class="up-down-icon"
              />
            </span>
          </button>
          @if (accordionItem.expanded) {
          <div
            class="faq-answer"
            role="region"
            [attr.id]="'faq-body-' + idx"
            [attr.aria-labelledby]="'faq-header-' + idx"
          >
            {{ getTranslationAnswer(faq) }}
          </div>
          }
        </cdk-accordion-item>
        }
      </cdk-accordion>
    </div>
    <app-content-loader [visible]="loading"></app-content-loader>
  </div>
  <div *ngIf="noData">
    <app-no-data-component></app-no-data-component>
  </div>
</section>
